export default "__VITE_ASSET__D4XNh8UG__"